import React from 'react';
import { AppRoutes } from './routes/AppRoutes';
import Header from './components/Header';
import Footer from './components/Footer';

import { FavoritesProvider } from './context/FavoritesContext';
import { setAuthToken } from './api/auth';
import ScrollToTop from './components/ScrollToTop';

import FeedbackButton from './components/FeedbackButton';
import { useAuth } from './AuthContext';

function App() {
  const { user } = useAuth?.() || {};

  React.useEffect(() => {
    const token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
    if (token) setAuthToken(token);
  }, [user]);

  return (
    <FavoritesProvider>
      <ScrollToTop />
      {/* Show feedback button only for logged-in users, overlaying the whole app */}
      {/* {user && user.username && <FeedbackButton />} */}
      <div className="flex flex-col min-h-full relative">
        <Header />
        <main className="flex-1 relative pt-[var(--header-height-mobile)] md:pt-[var(--header-height)]">
          <AppRoutes />
        </main>
        <Footer />
      </div>
    </FavoritesProvider>
  );
}

export default App;
